export enum Routes {
  Root = "/",
  Read = "/read",
  Process = "/process/:invoiceJobId",
  Verify = "/verify/:invoiceJobId",
  DisputeOpportunity = "/dispute-opportunity/:invoiceJobId",
  ContainerDetails = "/container-details/:invoiceContainerId",
  AlreadySent = "/already-sent/:invoiceJobId",
}
